import React from 'react';
import { IconProps } from './types';
import { ComponentSize } from '../types';

interface IconBaseProps extends IconProps {
  size20Component: React.ReactNode;
  size24Component: React.ReactNode;
  size16Component?: React.ReactNode;
  className?: string;
}

const IconBase = React.memo(function IconBase({
  size = 'md',
  className,
  size20Component,
  size24Component,
  size16Component,
}: IconBaseProps) {
  const pxSizes: Record<ComponentSize, number> = {
    xs: 16,
    sm: 20,
    md: 24,
  };

  const pxSize = pxSizes[size];

  const iconContentBySize: Record<ComponentSize, React.ReactNode> = {
    xs: size16Component || size20Component,
    sm: size20Component,
    md: size24Component,
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={`${pxSize}px`}
      viewBox="0 -960 960 960"
      width={`${pxSize}px`}
      fill="currentColor"
      className={className}
    >
      {iconContentBySize[size]}
    </svg>
  );
});

export default IconBase;
